/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExistingUserCreditUnionInputDto { 
    creditUnionName: string;
    description?: string | null;
    moduleType: string;
    isPublic?: boolean | null;
}

